<template>
    <div class="company-manage">
        <div class="banner-wrap">
            <div class="title">{{ management.title }}</div>
            <img class="banner" :src="management.mobileBanner.url" :alt="management.title" />
        </div>

        <index-bar :bars="indexBar"></index-bar>

        <div class="content">
            <div :id="indexBar[0]" class="title-wrap">{{ organization.title }}</div>
            <div class="content-wrap ck-content" v-html="organization.mobileContent"></div>

            <div :id="indexBar[1]" class="title-wrap">{{ directors.title }}</div>
            <div class="name-list">
                <info-box-component v-for="item in directors.list" :key="item.name" :item="item">
                    <div slot="name-slot">{{ item.name }}</div>
                    <div slot="title-slot">{{ item.title }}</div>
                    <div slot="title-des-slot">{{ item.titleDes }}</div>
                    <div slot="des-slot" v-html="item.description"></div>
                </info-box-component>
            </div>
            <div class="des ck-content" v-html="directors.content"></div>

            <div :id="indexBar[2]" class="title-wrap">{{ supervisors.title }}</div>
            <div class="name-list">
                <info-box-component v-for="item in supervisors.list" :key="item.name" :item="item">
                    <div slot="name-slot">{{ item.name }}</div>
                    <div slot="title-slot">{{ item.title }}</div>
                    <div slot="title-des-slot">{{ item.titleDes }}</div>
                    <div slot="des-slot" v-html="item.description"></div>
                </info-box-component>
            </div>
            <div class="des ck-content" v-html="supervisors.content"></div>

            <div :id="indexBar[3]" class="title-wrap">{{ senior.title }}</div>
            <div class="name-list">
                <info-box-component v-for="item in senior.list" :key="item.name" :item="item">
                    <div slot="name-slot">{{ item.name }}</div>
                    <div slot="title-slot">{{ item.title }}</div>
                    <div slot="title-des-slot">{{ item.titleDes }}</div>
                    <div slot="des-slot" v-html="item.description"></div>
                </info-box-component>
            </div>
            <div class="des ck-content" v-html="senior.content"></div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import infoBoxComponent from './components/info-box.vue'
import indexBar from './components/index-bar.vue'

export default {
    name: 'CompanyManage',
    components: {
        infoBoxComponent,
        indexBar
    },
    data() {
        return {
            directors: {},
            organization: {},
            management: {
                mobileBanner: {}
            },
            supervisors: {},
            senior: {},
            indexBar: []
        }
    },
    computed: {},
    created() {
        ajax.investorManagement().then(res => {
            this.management = res
        })
        ajax.investorOrganization().then(res => {
            this.organization = res
        })
        ajax.investorDirectors().then(res => {
            this.directors = res
        })
        ajax.investorSenior().then(res => {
            this.senior = res
        })
        ajax.investorSupervisors().then(res => {
            this.supervisors = res
        })
        ajax.getHomeMenus().then(homeRes => {
            const { menus = [] } = homeRes
            const investorRelationItem = menus.find(i => i.key === 'investorRelation')
            const { children } = investorRelationItem
            const bars = children.find(i => i.key === 'companyManage')
            this.indexBar = bars.indexBar
        })
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.company-manage {
    .banner-wrap {
        height: 480px;
        position: relative;
        .title {
            font-weight: 500;
            font-size: 60px;
            color: #ffffff;
            position: absolute;
            left: 40px;
            top: 80px;
        }
        .banner {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
    .content {
        padding: 0 40px 0 40px;
        .title-wrap {
            font-weight: 500;
            font-size: 42px;
            color: #333333;
            margin-bottom: 40px;
            margin-top: 60px;
        }
        .content-wrap {
            margin-bottom: 60px;
        }
        .des {
            font-weight: 400;
            font-size: 26px;
            color: #b3b3b3;
        }
        .name-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/company-manage.vue